import { useState, useEffect } from "react";
import { Row, Col, Typography, Button } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import planeAnimationVideo from "../../assets/videos/plane-animated-video.mp4";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

const { Title, Paragraph } = Typography;

const HomePageAnimatedSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const containerVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const handleVideoError = () => {
    setVideoError(true);
  };

  return (
    <div className="HomePageAnimatedSectionWrapper">
      <div className="header_main">
        <AnimatePresence>
          {isVisible && (
            <motion.div className="AnimationHeader" initial="hidden" animate="visible" exit="hidden" variants={containerVariants}>
              <Row gutter={[0, 0]} align="top" justify="start" className="first-row">
                <Col xs={24} md={11}>
                  <motion.div className="video-container" variants={itemVariants}>
                    {!videoError ? (
                      <video src={planeAnimationVideo} type="video/mp4" autoPlay loop muted playsInline onError={handleVideoError} />
                    ) : (
                      <div className="video-error-placeholder">{t("video-loading-error")}</div>
                    )}
                  </motion.div>
                </Col>
                <Col xs={24} md={13}>
                  <div className="AnimationContent">
                    <motion.div variants={itemVariants}>
                      <div level={1} className="main-title1 mt-20">
                        {t("its-simple-its-better-text")}
                      </div>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <Paragraph className="Header_description">{t("twizz-is-a-social-network-text")}</Paragraph>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <Paragraph className="Header_description">{t("twizz-was-developed-by-content-creator-text")}</Paragraph>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                      <Button type="primary" size="large" className="cta-button" onClick={() => navigate("/auth/intro")}>
                        {t("open-the-app")}
                      </Button>
                    </motion.div>
                  </div>
                </Col>
              </Row>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default HomePageAnimatedSection;
